export default [
	{
		title: "Structure",
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 2,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 3,
				text: "The course set the right priorities.",
			},
			{
				id: 4,
				text: "Methods and workload were clear from the course description.",
			},
		],
	},
	{
		title: "Requirements",
		type: "bi",
		id: 2,
		items: [
			{
				id: 5,
				text: "The difficulty of the content was…}too demanding}too little demanding",
			},
			{
				id: 6,
				text: "The amount of the content was…}too demanding}too little demanding",
			},
			{
				id: 7,
				text: "The amount of time required for the course (including preparation and follow-up) was…}too demanding}too little demanding",
			},
		],
	},
	{
		title: "Exercises",
		type: "uni",
		id: 3,
		items: [
			{
				id: 8,
				text: "The assignments helped in understanding the material.",
			},
			{
				id: 9,
				text: "The amount of exercises was adequate.",
			},
			{
				id: 10,
				text: "The difficulty of the exercise tasks was appropriate.",
			},
			{
				id: 11,
				text: "The exercises made me think the concepts through.",
			},
			{
				id: 12,
				text: "The exercises motivated me to further occupy myself with the contents of the course.",
			},
		],
	},
	{
		title: "Global",
		type: "uni",
		id: 4,
		items: [
			{
				id: 13,
				text: "Overall, this was a good course.",
			},
			{
				id: 14,
				text: "I learned a lot in this course.",
			},
			{
				id: 15,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 16,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "special",
		id: 5,
		items: [
			{
				id: 17,
				text: "Field of study",
				label: [
					{
						id: 1,
						text: "Mathematics",
					},
					{
						id: 2,
						text: "Physics",
					},
					{
						id: 3,
						text: "Computer Science",
					},
					{
						id: 4,
						text: "Other",
					},
				],
			},
			{
				id: 18,
				text: "Did you use any other literature during the lecture?",
				label: [
					{
						id: 1,
						text: "Always",
					},
					{
						id: 2,
						text: "Often",
					},
					{
						id: 3,
						text: "Sometimes",
					},
					{
						id: 4,
						text: "Rarely",
					},
					{
						id: 5,
						text: "Never",
					},
				],
			},
			{
				id: 19,
				text: "Approximately what percentage of the assignment do you hand in?",
				label: [
					{
						id: 1,
						text: "100%",
					},
					{
						id: 2,
						text: "75%",
					},
					{
						id: 3,
						text: "50%",
					},
					{
						id: 4,
						text: "25%",
					},
					{
						id: 5,
						text: "0%",
					},
				],
			},
			{
				id: 20,
				text: "What percentage do you solve yourself?",
				label: [
					{
						id: 1,
						text: "100%",
					},
					{
						id: 2,
						text: "75%",
					},
					{
						id: 3,
						text: "50%",
					},
					{
						id: 4,
						text: "25%",
					},
					{
						id: 5,
						text: "0%",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [
			{
				id: 21,
				text: "Further remarks: I especially appreciated",
				size: "default",
			},
			{
				id: 22,
				text: "Further remarks: I did not like",
				size: "default",
			},
			{
				id: 23,
				text: "Further remarks: Suggestions for improvements",
				size: "default",
			},
		],
	},
	{
		type: "dsp",
		id: 7,
		items: [
			{
				id: 24,
				text: "The lecturer provided the opportunity to ask questions.",
			},
			{
				id: 25,
				text: "The lecturer could answer questions very well.",
			},
			{
				id: 26,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 27,
				text: "The lecturer was accessible to me.",
			},
			{
				id: 28,
				text: "The range of support offered by the lecturer (e.g. office hours) was adequate.",
			},
		],
	},
];
